import { createStore, createHook, type StoreActionApi } from 'react-sweet-state';

type State = {
	rankParentIssueId: string | null;
};

const actions = {
	setRankParentIssueId:
		(rankParentIssueId: string | null) =>
		({ setState }: StoreActionApi<State>) =>
			setState({ rankParentIssueId }),
} as const;

type Actions = typeof actions;

const Store = createStore<State, Actions>({
	initialState: { rankParentIssueId: null },
	actions,
	name: 'JBusListViewRankParentIssueIdStore',
});

export const useRankParent = createHook(Store);
